import React, { createContext, useReducer, useState, useContext } from "react";
import { authRefReducer } from "../Reducer/AuthRefReducer";
import { authAccReducer } from "../Reducer/AuthAccReducer";
import { userReducer } from "../Reducer/UserReducer";
import { userContext } from "./UserContext";
import Cookies from "js-cookie";

const AuthContext = createContext();

const AuthProvider = (props) => {
    const [authRef, authRefDispatch] = useReducer(authRefReducer, {
        refToken: "",
    });
    const [authAcc, authAccDispatch] = useReducer(authAccReducer, {
        accToken: "",
    });

    const [authUser, authUserDispatch] = useReducer(userReducer, {
        user: "",
        adminId: "",
        userId: "",
    });

    return (
        <AuthContext.Provider
            value={{
                authRef,
                authRefDispatch,
                authAcc,
                authAccDispatch,
                authUser,
                authUserDispatch,
            }}
            {...props}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
